"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _base = require("./base");

var PersonRootBlock =
/*#__PURE__*/
function (_BlockContainer) {
  babelHelpers.inherits(PersonRootBlock, _BlockContainer);

  function PersonRootBlock() {
    babelHelpers.classCallCheck(this, PersonRootBlock);
    return babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(PersonRootBlock).apply(this, arguments));
  }

  return PersonRootBlock;
}(_base.BlockContainer);

exports.default = PersonRootBlock;